import React from 'react';

import * as S from './RoomSelectionHeader.styles';

// import {WrapperDiv, ItemWrapperDiv, TextStylingWrapperSpan} from './RoomSelectionHeader.styles';

const RoomSelectionHeader = ({noInclusionsAndSplInstructionsForAnyRoom}) => (
  <S.RoomSelectHeadWrap>
    <S.RoomTypeWrap>
      <S.RoomTypeHeadText>Room type</S.RoomTypeHeadText>
    </S.RoomTypeWrap>
    <S.RatePlanWrap>
      <S.RoomTypeHeadText>Rate plan</S.RoomTypeHeadText>
    </S.RatePlanWrap>
    {/* {(!noInclusionsAndSplInstructionsForAnyRoom && (
      <S.RatePlanWrap>
        <S.RoomTypeHeadText>Inclusions</S.RoomTypeHeadText>
      </S.RatePlanWrap>
    )) || null} */}
    <S.RoomPricePriceWrap>
      <S.RoomTypeHeadText>Total Payable</S.RoomTypeHeadText>
    </S.RoomPricePriceWrap>
  </S.RoomSelectHeadWrap>
  // <WrapperDiv id="room-selection-table-header">
  //   <ItemWrapperDiv>
  //     <TextStylingWrapperSpan>Room Type</TextStylingWrapperSpan>
  //   </ItemWrapperDiv>
  //   <ItemWrapperDiv>
  //     <TextStylingWrapperSpan>Room Options</TextStylingWrapperSpan>
  //   </ItemWrapperDiv>

  //   {!noInclusionsAndSplInstructionsForAnyRoom && (
  //     <ItemWrapperDiv>
  //       <TextStylingWrapperSpan>Inclusions</TextStylingWrapperSpan>
  //     </ItemWrapperDiv>
  //   )}

  //   <ItemWrapperDiv>
  //     <TextStylingWrapperSpan>Price</TextStylingWrapperSpan>
  //   </ItemWrapperDiv>
  // </WrapperDiv>
);

export default RoomSelectionHeader;
